import React, { useEffect, useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './GameRowItem.scss';
import { useDispatch, useHistory, useIntl } from 'umi';
import RenderGameIcon from '../../RenderImg/renderGameIcon';
import { handleGameClick } from '@/pages/opinion/utils/game';
import { Bubble } from 'tea-component';

import { gameCollectAdd, gameCollectDel } from '@op/services';
import { keywordRenderFunc } from '@op/utils/text';

export default function GameRowItem({
  gameInfo,
  isSubGameList = false,
  hasMoreArrow = false,
  isSelected = false,
  isCollect,
  handleCollect,
  searchText,
}: {
  gameInfo: any;
  isSubGameList?: boolean;
  hasMoreArrow?: boolean;
  isSelected?: boolean;
  isCollect?: boolean;
  handleCollect?: () => {};
  searchText?: string;
}) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();

  const desc = gameInfo.entity_name_cn || gameInfo.entity_name;

  const handleClick = () => {
    handleGameClick(gameInfo, dispatch, history, true);
  };

  if (isSubGameList) {
    return (
      <div
        className={`drawer-more-item  ${isSelected ? 'is-selected' : ''}`}
        onClick={handleClick}
      >
        <RenderGameIcon
          gameInfo={gameInfo}
          className="drawer-more-avatar game-row-item-image"
        ></RenderGameIcon>

        <div className="drawer-more-info">
          <div className="drawer-more-info-tit">
            {gameInfo.isAllEditions
              ? formatMessage({ id: 'All Editions' })
              : gameInfo.entity_name}
          </div>
          <span className="drawer-more-info-desc">{desc}</span>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div className="drawer-context-left" onClick={handleClick}>
          <RenderGameIcon
            gameInfo={gameInfo}
            className="drawer-game-avatar game-row-item-image"
          ></RenderGameIcon>

          <div className="drawer-context-flex">
            <div className="drawer-context-left-text-info">
              <div className="drawer-context-left-text">
                {searchText
                  ? keywordRenderFunc({
                      text: gameInfo.entity_name,
                      keyword: searchText,
                    })
                  : gameInfo.entity_name}
              </div>
              {/* {isCollect ? (
                <Collect gameInfo={gameInfo} handleCollect={handleCollect} />
              ) : null} */}
            </div>
            <div className="drawer-context-left-desc">
              <SvgIcon
                className="all-game-icon drawer-context-left-desc-icon"
                type={
                  gameInfo.entity_type == 'mobile'
                    ? 'other-icon'
                    : gameInfo.entity_type == 'pc'
                    ? 'monitor'
                    : 'merit'
                }
              />
              <span>{desc}</span>
            </div>
          </div>
        </div>

        {hasMoreArrow && (
          <span className="drawer-context-more">
            <SvgIcon type="point-right" />
          </span>
        )}
      </>
    );
  }
}

const Collect = (props: any) => {
  const { gameInfo = {}, handleCollect = () => {} } = props;

  const { formatMessage } = useIntl();

  const [collect, setCollect] = useState(gameInfo?.collect || false);

  useEffect(() => {
    // console.log('gameInfo', gameInfo, gameInfo.collect);
    setCollect(gameInfo.collect);
  }, [gameInfo]);

  return (
    <>
      <Bubble
        dark
        closeOnScroll
        content={formatMessage({ id: collect ? 'Following' : 'Follow' })}
      >
        <span
          className="dbo-collect-icon-box"
          onClick={async (e) => {
            e.stopPropagation();
            e.preventDefault();

            // 接口处理

            try {
              let res;
              if (collect) {
                res = await gameCollectDel({
                  edition_unified_ids: [gameInfo.edition_unified_id],
                });
                // 取消关注
              } else {
                // 关注
                res = await gameCollectAdd({
                  edition_unified_ids: [gameInfo.edition_unified_id],
                });
              }

              // 这里需要像后台发起请求，成功以后才进行下面的上报处理
              setCollect(!collect);
              handleCollect?.(!collect, gameInfo);
            } catch (error) {
              console.log('collect error', error);
            }

            return false;
          }}
        >
          <SvgIcon
            type={collect ? 'star-action' : 'star-m'}
            className="dbo-collect-icon"
          />
        </span>
      </Bubble>
    </>
  );
};
